export const IS_STAGING = process.env.VERCEL_GITLAB_COMMIT_REF === "staging";
